import React from "react";
import { strings } from "../../resources/strings";

interface ChatNavBadgeProps {
  count: number;
}

/**
 * Presentational unread pill for the Chat nav item. Rendered in both the
 * desktop header and the mobile drawer; the count comes from the single
 * ChatUnreadWatcher instance Navbar mounts (never fetch/subscribe here — both
 * render sites stay mounted on every viewport, which would double the
 * subscriptions).
 */
const ChatNavBadge: React.FC<ChatNavBadgeProps> = ({ count }) => {
  if (count <= 0) {
    return null;
  }

  return (
    <span
      data-testid="chat-nav-badge"
      aria-label={`${count} ${strings.chat.unreadMessages}`}
      className="inline-flex items-center justify-center min-w-5 h-5 px-1.5 ml-2 rounded-full bg-secondary text-primary text-xs font-bold leading-none"
    >
      {count > 9 ? "9+" : count}
    </span>
  );
};

export default ChatNavBadge;
